module.exports = __webpack_public_path__ + "img/person-praying.c7929af0.svg";